import { BankAccountDto } from "./bankAccount";

export type InvoiceDetailsDto = {
    id: string;
    invoiceDate?: string;
    invoiceDueDate?: string;
    invoiceNumber?: string;
    claimsRef?: string;
    subClaimsRef?: string;
    correspondentCosts?: number;
    surveyorCosts?: number;
    expertCosts?: number;
    lawyerFees?: number;
    lawyerExpenses?: number;
    counselFees?: number;
    courtArbitFees?: number;
    otherExpenses?: number;
    claimSettlements?: number;
    advanceOfFunds?: number;
    previousAdvanceOfFunds?: number;
    totalVatAmount?: number;
    totalLocalTax?: number;
    correctAmountVerified: boolean;
    isLastInvoice: boolean;
    vesselName?: string;
    clientName?: string;
    clientVat?: string;
    incidentDate?: string;
    submittedDate?: string;
    status: InvoiceStatus;
    bankAccount?: BankAccountDto;
    attachment?: AttachmentDto;
    activityId?: number;
    submittedOnBehalfOfCrmId?: string;
    submittedOnBehalfOfCompanyName?: string;
    branchCompanyCrmId?: string;
    rejectedReason?: string;
};

export type AttachmentDto = {
    documentId: string;
    filename: string;
    fileExtension: string;
    fileSize: number;
};

export enum invoiceStatusValues {
    Draft = "Draft",
    Deleted = "Deleted",
    Submitted = "Submitted",
    InProgress = "InProgress",
    Rejected = "Rejected",
    InProcess = "InProcess",
    Approved = "Approved",
    Archived = "Archived",
    Error = "Error",
    Scheduled = "Scheduled",
    SubmitFailed = "SubmitFailed",
    Cancelled = "Cancelled"
}

export type InvoiceStatus = keyof typeof invoiceStatusValues;

export type InvoiceAttachment = {
    filename: string;
    fileSize: number;
    fileExtension: string | undefined;
    isUploading: boolean;
    isUploaded: boolean;
    uploadFailed: boolean;
    file?: File;
    docId?: string;
};

export type InvoiceFormData = {
    invoiceDate: string | undefined;
    invoiceDueDate: string | undefined;
    invoiceNumber: string | undefined;
    bankAccount: BankAccountDto | undefined;
    invoiceAttachment: InvoiceAttachment | undefined;
    claimRef: string | undefined;
    subClaimsRef: string | undefined;
    correspondentCosts: string | undefined;
    surveyorCosts: string | undefined;
    expertCosts: string | undefined;
    lawyerFees: string | undefined;
    lawyerExpenses: string | undefined;
    counselFees: string | undefined;
    courtArbitFees: string | undefined;
    totalVatAmount: string | undefined;
    totalLocalTax: string | undefined;
    otherExpenses: string | undefined;
    claimSettlements: string | undefined;
    addressConfirmation: boolean;
    totalConfirmation: boolean;
    advanceOfFunds: string | undefined;
    previousAdvanceOfFunds: string | undefined;
    personalSensitiveConfirmation: boolean;
    vesselName: string | undefined;
    clientName: string | undefined;
    clientVat: string | undefined;
    submittedOnBehalfOfCrmId: string | undefined;
    submittedOnBehalfOfCompanyName: string | undefined;
    branchCompanyCrmId: string | undefined;
    hasLawyerAndCounselFees: boolean;
    hasAdvanceOfFunds: boolean;
};

export type InsertInvoiceDto = {
    invoiceDate?: string;
    invoiceDueDate?: string;
    invoiceNumber?: string;
    claimsRef?: string;
    subClaimsRef?: string;
    correspondentCosts?: number;
    surveyorCosts?: number;
    expertCosts?: number;
    lawyerFees?: number;
    lawyerExpenses?: number;
    counselFees?: number;
    courtArbitFees?: number;
    otherExpenses?: number;
    claimSettlements?: number;
    advanceOfFunds?: number;
    totalVatAmount?: number;
    totalLocalTax?: number;
    bankAccount?: BankAccountDto;
    correctAmountVerified?: boolean;
    previousAdvanceOfFunds?: number;
    vesselName?: string;
    clientName?: string;
    clientVat?: string;
    submittedOnBehalfOfCrmId?: string;
    submittedOnBehalfOfCompanyName?: string;
    branchCompanyCrmId?: string;
};

/**
 * KeysMatchingValue
 * Keep only the keys of ObjectShape whose value type matches TargetValueType.
 */
type KeysMatchingValue<ObjectShape, TargetValueType> = keyof {
    [PropertyName in keyof ObjectShape as ObjectShape[PropertyName] extends TargetValueType
        ? PropertyName
        : never]: true;
};

export type NumericStringFieldKeys = KeysMatchingValue<InvoiceFormData, string | undefined>;
